import React from 'react';

export default function VoidField() {
    return <React.Fragment/>;
}
